'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _registrations = require('ifeis-isomorphic/lib/redux/actions/registrations');

var _paths = require('ifeis-isomorphic/lib/redux/actions/cart/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/person/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeregisterController = function () {
  function DeregisterController(user, feis, $mdDialog, $ngRedux, $window) {
    _classCallCheck(this, DeregisterController);

    this._ = { $window: $window, $ngRedux: $ngRedux, $mdDialog: $mdDialog };
    this.feis = feis;
    this.user = user;

    this.filter = '';
    this.isAllCheckboxSelected = false;
    this.selectedAccounts = {};
    this.isDeregistering = false;

    $ngRedux.dispatch((0, _registrations.setDeregisteringFlag)(feis.id, this.isDeregistering));
    $ngRedux.dispatch((0, _feiseanna.getUnpaidCompetitorsForFeis)(feis.id));
    $ngRedux.dispatch((0, _cart.getUnpaidAccountsForFeis)(feis.id));
    $ngRedux.connect(function (state) {
      return {
        isDeregistering: (0, _paths.getDeregisteredFlag)(state, feis.id),
        paymentsDue: (0, _paths.getAccountsCarts)(state, feis.id),
        unpaidPrtsGroupedByAccount: (0, _paths3.getPersonsForFeis)(state, feis.id).filter(function (p) {
          return !p.get('paid');
        }).map(function (up, i) {
          return (0, _paths2.getPerson)(state, i);
        }).groupBy(function (pd) {
          return pd.get('account_id');
        }).map(function (values) {
          return values.map(function (p) {
            return p.toJS();
          }).toArray();
        }).toJS(),

        unpaidAccounts: (0, _paths3.getAccountsForFeis)(state, feis.id).filter(function (a) {
          return !a.get('paid') && a.get('balance') > 0;
        }).map(function (ua, i) {
          return (0, _paths2.getPerson)(state, i).toJS();
        })
      };
    })(this);
  }

  _createClass(DeregisterController, [{
    key: 'isNoAccountSelected',
    value: function isNoAccountSelected() {
      return angular.equals(this.selectedAccounts, {});
    }
  }, {
    key: 'selectDeselectAllAccounts',
    value: function selectDeselectAllAccounts(wasSelected) {
      var _this = this;

      if (!wasSelected) {
        this.unpaidAccounts.forEach(function (acc) {
          return _this.selectedAccounts[acc.id] = true;
        });
      } else {
        this.selectedAccounts = {};
      }
    }
  }, {
    key: 'selectDeselectOneAccount',
    value: function selectDeselectOneAccount(account) {
      // If account is selected - deselect it
      if (this.selectedAccounts[account.id]) {
        this.selectedAccounts[account.id] = false;
        // Also, here we need to deselect the "All" checkbox if at least one account is deselected
        if (this.isAllCheckboxSelected) this.isAllCheckboxSelected = false;
      } else {
        this.selectedAccounts[account.id] = true;
      }
    }
  }, {
    key: 'confirmAndDeregister',
    value: function confirmAndDeregister() {
      var _this2 = this;

      // Prepare selected accounts
      // and unpaid participants for the selected accounts to be deregistered
      var selectedAccounts = this.unpaidAccounts.filter(function (a) {
        return _this2.selectedAccounts[a.id];
      }),
          prtsToDeregister = [];

      selectedAccounts.forEach(function (a) {
        var participants = _this2.unpaidPrtsGroupedByAccount[a.id];
        prtsToDeregister = [].concat(_toConsumableArray(prtsToDeregister), _toConsumableArray(participants));
      });

      var msg = 'Are you sure you want to unregister ' + selectedAccounts.size + ' selected account' + (selectedAccounts.size > 1 ? 's' : '') + '? \n               This will unregister ' + prtsToDeregister.length + ' participant' + (prtsToDeregister.length > 1 ? 's' : '') + ' in total.';

      var dialog = this._.$mdDialog.confirm().title('Unregister unpaid participants').textContent(msg).cancel('Cancel').ok('Unregister Now');

      // Display confirmation dialog, and
      // if user confirms, deregister participants
      this._.$mdDialog.show(dialog).then(function (confirmed) {
        _this2.isDeregistering = true;
        if (confirmed) _this2.deregisterSelectedAccounts(prtsToDeregister);
      });
    }
  }, {
    key: 'deregisterSelectedAccounts',
    value: function deregisterSelectedAccounts(participantsToDeregister) {
      var _this3 = this;

      // Deregister every selected participant from every event she is registered in this feis. Deregistration happens at server now;

      this._.$ngRedux.dispatch((0, _registrations.setDeregisteringFlag)(this.feis.id, this.isDeregistering));

      var promiseArray = participantsToDeregister.map(function (participant) {
        return _this3._.$ngRedux.dispatch((0, _cart.unregisterPerson)(_this3.feis.id, participant.id, participant.account_id));
      });

      Promise.all(promiseArray).then(function () {
        _this3.isDeregistering = false;
        return _this3._.$ngRedux.dispatch((0, _registrations.setDeregisteringFlag)(_this3.feis.id, _this3.isDeregistering));
      });
    }
  }, {
    key: 'emailToSelectedAccounts',
    value: function emailToSelectedAccounts() {
      var _this4 = this;

      var allSelectedEmails = '';
      this.unpaidAccounts.forEach(function (ua) {
        if (_this4.selectedAccounts[ua.id]) {
          allSelectedEmails = '' + (allSelectedEmails ? allSelectedEmails + ',' : '') + ua.email;
        }
      });
      this._.$window.open('mailto:' + this.user.email + '?bcc=' + allSelectedEmails + '&subject=' + this.feis.name + ': Your Unpaid Registration', '_self');
    }
  }]);

  return DeregisterController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.deregister', ['ngMaterial', 'ui.router', 'ngRedux']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.deregister', {
    controller: 'DeregisterController',
    controllerAs: 'deregister',
    template: require('./tpl.html'),
    url: '/deregister',
    resolve: {
      user: function user(fSession) {
        return fSession.user();
      }
    },
    ncyBreadcrumb: {
      label: 'Drop Unpaid Registrants',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).controller('DeregisterController', DeregisterController).filter('accountsFilter', function () {
  return function (array, searchTerm, unpaidPrtsGroupedByAccount) {
    if (!array || !searchTerm || searchTerm === "") return array;

    return array.filter(function (account) {
      var foundInAccountDetails = account.fname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || account.lname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || account.email.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || (account.events || []).findIndex(function (ev) {
        return ev.toLowerCase().includes(searchTerm.toLowerCase());
      }) > -1;

      var participants = unpaidPrtsGroupedByAccount && unpaidPrtsGroupedByAccount[account.id];
      var foundInParticipantsDetails = participants.find(function (p) {
        return p.fname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || p.lname.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || p.school.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 || (p.events || []).findIndex(function (ev) {
          return ev.toLowerCase().includes(searchTerm.toLowerCase());
        }) > -1;
      });

      return foundInAccountDetails || !!foundInParticipantsDetails;
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/deregister/index.js
// module id = 543
// module chunks = 0